export default "__VITE_ASSET__3fcfad5f__"